import { Ref, ref } from "vue";
import cms from "../services/cms/cms";
import { CmsPersonalPathway } from "../services/cms/cms-type-definitions";
import { PersonalPathwayUserProgressApiModel } from "../api-models";
import { csContext } from "../services/cs-context";
import { useAxios } from "./api";

export type UseSelectPersonalPathwayResponse = {
  error: Ref<boolean>;
  success: Ref<boolean>;
  isLoading: Ref<boolean>;
};

function useSelectPersonalPathway(pathway: CmsPersonalPathway): UseSelectPersonalPathwayResponse {
  // get the pathway
  const error = ref(false);
  const success = ref(false);
  const isLoading = ref(true);

  const selectedPathway: PersonalPathwayUserProgressApiModel = {
    userId: csContext.user.id,
    cmsPersonalOutcomeId: pathway.data.goal_relationship.id,
    cmsPersonalOutcomeUid: pathway.data.goal_relationship.uid,
    cmsPersonalOutcomeTitle: cms.asText(pathway.data.goal_relationship.data?.full_title),
    cmsPersonalPathwayId: pathway.id,
    cmsPersonalPathwayUid: pathway.uid ?? "",
    cmsPersonalPathwayTitle: cms.asText(pathway.data.title),
    isCurrent: true,
    totalPathwayStepCount: pathway.data.pathway_steps.length,
    isCompleted: false,
  };

  const { promise } = useAxios("/api/personalpathway", {
    httpMethod: "POST",
    data: selectedPathway,
    isFatal: false,
  });
  promise
    .then(() => {
      success.value = true;
      isLoading.value = false;
    })
    .catch(() => {
      error.value = true;
      isLoading.value = false;
    });

  return { error, success, isLoading };
}

export default useSelectPersonalPathway;
